import { queryOptions } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

interface OrganizationsQuery {
  /** Only this channel's organizations. The app's "None" channel means every channel. */
  channel?: string;
  /** Staff only: primary organizations, across account managers. */
  primaryOnly?: boolean;
  /** Staff only: include hidden organizations. */
  allOrgs?: boolean;
  /** Include each organization's MCP token, which the backend mints per request. */
  includeMcpToken?: boolean;
}

export const getOrganizationsOptions = ({
  channel,
  primaryOnly,
  allOrgs,
  includeMcpToken,
}: OrganizationsQuery = {}) => {
  const queries = {
    org_type: channel && channel !== "None" ? channel : undefined,
    primary_only: primaryOnly,
    all_orgs: allOrgs,
    include_mcp_token: includeMcpToken,
  };

  return queryOptions({
    queryKey: [{ entity: "organizations", params: queries }],
    queryFn: async () => await apiClient.getOrganizations({ queries }),
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  });
};
